$(document).ready(function () {
    $('.res-logos-fixed .logos-inner').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 766,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 534,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    console.log("Res Logos Fixed");
});